import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchTextField } from '../../SearchTextField/SearchTextField';
import Box from '@mui/material/Box';
import { SearchTypeAhead } from '@im/ui-lib/SearchTypeAhead';
import { removeLsObject } from '@im/ui-lib/utils/local-storage.utils';
import { jsx as _jsx } from "react/jsx-runtime";
var categories = ['Products', 'Bundle', 'Vendor Store', 'My Ingram Micro', 'Promotions', 'Resources'];
export function ProductSearchAutocomplete(props) {
  var enableAISuggestions = props.enableAISuggestions,
    getSearchSuggestions = props.getSearchSuggestions,
    isCmpWhitelisted = props.isCmpWhitelisted;
  var navigate = useNavigate();
  var _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid;
  function onSearch(value) {
    return new Promise(function (resolve, reject) {
      try {
        var _value$source;
        var queryParam = value.searchType;
        var url = encodeURIComponent("".concat(value.text));
        var source = (_value$source = value.source) != null ? _value$source : '';
        var sourceParam = source !== '' ? "&source=".concat(source) : '';
        removeLsObject('selectedTab');
        removeLsObject('DisableSuggestionSearch');
        navigate("/product/productsearch?".concat(queryParam, "=").concat(url, "&displaytitle=").concat(url, "&sortBy=relevance").concat(sourceParam));
        resolve(true);
      } catch (e) {
        resolve(false);
      }
    });
  }
  return /*#__PURE__*/_jsx(Box, {
    height: "32px",
    margin: "0 15px",
    width: "40rem",
    "data-element": "Box",
    "data-component": "ProductSearchAutocomplete",
    "data-source-file": "ProductSearchAutocomplete.tsx",
    children: isCmpWhitelisted ? /*#__PURE__*/_jsx(SearchTypeAhead, {
      categories: categories,
      "data-testid": testid,
      enableAISuggestions: enableAISuggestions,
      getSearchSuggestions: getSearchSuggestions,
      onSearch: onSearch
    }) : /*#__PURE__*/_jsx(SearchTextField, {
      categories: categories,
      "data-testid": testid,
      enableAISuggestions: enableAISuggestions,
      getSearchSuggestions: getSearchSuggestions,
      onSearch: onSearch
    })
  });
}